export const mapState = {
    center: [70, 96],
    zoom: 5,
    type: null,
    // options: [],
    controls: []
};

export const COLORS = ["#193B94", "#FB6C3F", "#3D4C76", "#49C0B5"];
